import { motion } from 'framer-motion';
import { TruckIcon, MapPinIcon } from '@heroicons/react/24/outline';
import transportImage from '../../../assets/images/Transport.jpg';

const TransportSection = () => {
  const districts = ['RAHMA', 'DAR BOUAZZA', 'BEAUSÉJOUR'];

  return (
    <div className="py-16 bg-primary/10">
      <div className="container mx-auto px-4">
        <motion.div 
          className="bg-white rounded-2xl shadow-elegant overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="flex flex-col lg:flex-row">
            {/* Left side - Illustration */}
            <div className="lg:w-1/3 bg-primary p-8 flex flex-col h-full">
              {/* Top section - Icon and text */}
              <div className="mb-8">
                <div className="text-center">
                  <TruckIcon className="h-24 w-24 mx-auto text-white mb-6" />
                  <h3 className="text-white text-2xl font-bold mb-4">Transport Scolaire</h3>
                  <p className="text-white/80">Service de transport sécurisé pour nos élèves</p>
                </div>
              </div>
              
              {/* Bottom section - Image taking full remaining space */}
              <div className="flex-grow">
                <img 
                  src={transportImage} 
                  alt="Transport scolaire" 
                  className="w-full h-full object-cover rounded-lg shadow-md"
                />
              </div>
            </div>
            
            {/* Right side - Information */}
            <div className="lg:w-2/3 p-8 md:p-12">
              <div className="mb-6">
                <span className="inline-block bg-primary text-white px-3 py-1 text-sm font-medium rounded-md mb-2">NOUVEAU</span>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Informations liées au transport scolaire</h2>
                <p className="text-lg text-gray-700">
                  En plus des destinations déjà desservies le Groupe Scolaire Sanaa assurera le transport aux quartiers:
                </p>
              </div>
              
              <div className="mb-8">
                <ul className="space-y-4">
                  {districts.map((district, index) => (
                    <motion.li 
                      key={district}
                      className="flex items-center"
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                    >
                      <MapPinIcon className="h-6 w-6 text-primary mr-3" />
                      <span className="text-lg font-medium">{district}</span>
                    </motion.li>
                  ))}
                </ul>
              </div>
              
              <div className="text-gray-700 bg-gray-50 p-4 rounded-lg border-l-4 border-primary">
                <p className="text-sm">
                  Pour plus d'informations sur le service de transport scolaire, veuillez contacter l'administration de l'école ou consulter la page de contact.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TransportSection;